/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9jaHJvbm9jYXNoVjMvdGVzdC93ZWJhcHAtY2xrL3NyYy9hcHAvc2hhcmVkL2NvbXBvbmVudHMvYWxlcnQtY29uZmlybWF0aW9uL2FsZXJ0LWNvbmZpcm1hdGlvbi5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvY2hyb25vY2FzaFYzL3Rlc3Qvd2ViYXBwLWNsay9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL2FsZXJ0LWNvbmZpcm1hdGlvbi9hbGVydC1jb25maXJtYXRpb24uY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/shared/components/alert-confirmation/alert-confirmation.component.scss.shim.ngstyle.ts